import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fetch-branch"
export default class extends Controller {
  static targets = ["postalCode", "address", "tel"];
  connect() {
    console.log("fetchBranchController connected");
  }

  async fetchBranchAndSetAddress(event) {
    const branchId = event.target.value;
    if (!branchId) return;

    const branch = await this.fetchBranch(branchId);
    if (!branch) return;

    if (this.hasPostalCodeTarget)
      this.postalCodeTarget.value = branch.postal_code;
    if (this.hasAddressTarget) this.addressTarget.value = branch.address;
    if (this.hasTelTarget) this.telTarget.value = branch.tel;
  }

  async fetchBranchAndSetValues() {
    const branchId = this.element.value;
    if (!branchId) return;

    const branch = await this.fetchBranch(branchId);
    if (!branch) return;

    const departmentIdInput = document.querySelector("[id$=_department_id]");
    const quoteRepresentativeInput = document.querySelector(
      "[id$=quote_representative]"
    );

    const orderRepresentativeInput = document.querySelector(
      "[id$=_representative]"
    );

    const clientRepresentativeInput = document.querySelector(
      "[id$=_client_representative]"
    );

    const productTypeInput = document.querySelector("[id$=_product_type]");

    if (departmentIdInput) departmentIdInput.value = branch.department_id;

    if (quoteRepresentativeInput)
      quoteRepresentativeInput.value = branch.default_representative;

    if (orderRepresentativeInput)
      orderRepresentativeInput.value = branch.default_representative;

    if (clientRepresentativeInput)
      clientRepresentativeInput.value = branch.default_client_representative;

    if (productTypeInput) productTypeInput.value = branch.default_product_type;
  }

  async fetchBranch(branchId) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/branches/${branchId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken
      },
      credentials: "same-origin"
    });

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} ${response.statusText}`);
      return {};
    }

    return await response.json();
  }
}
